export const messages = {
  en: {
    transferGoodsManage: {
      recipient: 'Recipient',
      requiredContact: 'Required, please fill in the contact',
      selectRecipient: 'Select Recipient',
      transferDescription: 'Transfer Description',
      requiredDescription: 'Required, please fill in the transfer description',
      goodsInfo: 'Goods Information',
      selectGoods: 'Select Goods',
      goodsName: 'Goods Name',
      goodsCode: 'Goods Code',
      goodsType: 'Goods Type',
      isFixedGoods: 'Is Fixed Goods',
      goodsStock: 'Goods Stock',
      miniStock: 'Minimum Stock',
      transferQuantity: 'Transfer Quantity',
      remark: 'Remark',
      operation: 'Operation',
      remove: 'Remove',
      submit: 'Submit',
      selectGoodsType: 'Select Goods Type',
      selectSubCategory: 'Select Sub Category',
      inputGoodsName: 'Input Goods Name',
      cannotTransferToSelf: 'Cannot transfer to yourself',
      selectRecipientFirst: 'Please select recipient first',
      fillDescriptionFirst: 'Please fill in description first',
      selectGoodsFirst: 'Please select goods first',
      fillQuantityFirst: 'Please fill in quantity first',
      insufficientStock: 'Insufficient stock',
      orgInfo: 'Organization Information',
      staffInfo: 'Staff Information',
      selectStaffFirst: 'Please select staff first'
    }
  },
  zh: {
    transferGoodsManage: {
      recipient: '受赠人',
      requiredContact: '必填，请填写联系人',
      selectRecipient: '选择受赠人',
      transferDescription: '转赠说明',
      requiredDescription: '必填，请填写转赠说明',
      goodsInfo: '物品信息',
      selectGoods: '选择物品',
      goodsName: '物品名称',
      goodsCode: '物品编码',
      goodsType: '物品类型',
      isFixedGoods: '是否是固定物品',
      goodsStock: '物品库存',
      miniStock: '最小计量总数',
      transferQuantity: '转赠数量',
      remark: '备注',
      operation: '操作',
      remove: '移除',
      submit: '提交',
      selectGoodsType: '请选择物品类型',
      selectSubCategory: '请选择二级分类',
      inputGoodsName: '输入物品名称',
      cannotTransferToSelf: '不能转赠给自己',
      selectRecipientFirst: '请先选择受赠人',
      fillDescriptionFirst: '请先填写转赠说明',
      selectGoodsFirst: '请先选择物品',
      fillQuantityFirst: '请先填写数量',
      insufficientStock: '库存不足',
      orgInfo: '组织信息',
staffInfo: '员工信息',
      selectStaffFirst: '请先选择员工'
    }
  },
  'zh-TW': {
    transferGoodsManage: {
      recipient: '受贈人',
      requiredContact: '必填，請填寫聯繫人',
      selectRecipient: '選擇受贈人',
      transferDescription: '轉贈說明',
      requiredDescription: '必填，請填寫轉贈說明',
      goodsInfo: '物品信息',
      selectGoods: '選擇物品',
      goodsName: '物品名稱',
      goodsCode: '物品編碼',
      goodsType: '物品類型',
      isFixedGoods: '是否是固定物品',
      goodsStock: '物品庫存',
      miniStock: '最小計量總數',
      transferQuantity: '轉贈數量',
      remark: '備註',
      operation: '操作',
      remove: '移除',
      submit: '提交',
      selectGoodsType: '請選擇物品類型',
      selectSubCategory: '請選擇二級分類',
      inputGoodsName: '輸入物品名稱',
      cannotTransferToSelf: '不能轉贈給自己',
      selectRecipientFirst: '請先選擇受贈人',
      fillDescriptionFirst: '請先填寫轉贈說明',
      selectGoodsFirst: '請先選擇物品',
      fillQuantityFirst: '請先填寫數量',
      insufficientStock: '庫存不足',
      orgInfo: '組織信息',
      staffInfo: '員工信息',
      selectStaffFirst: '請先選擇員工'
    }
  }
}